// extracted by mini-css-extract-plugin
export default {"dateField":"style_dateField__XOX9d","label":"style_label__36AJT","error":"style_error__+P-UE"};